import React from "react";
import { useStyles } from "./proposalsStyles";
import Box from "@mui/material/Box";
import { constants } from "../../constants";
import StaticCard from "../StaticCard/StaticCard";
import { IFollowUp } from "../../services/interface/data";
import { IProposals } from "./IProposals";

const Proposals = ({ data, handleSubmitPrompt }: IProposals) => {
    const { classes } = useStyles({ backgroundImage: undefined });

    return (
        <Box data-name="Proposals" className={classes.root}>
            <Box id="proposals" className={classes.container}>
                <span className={classes.heading}>
                    {constants.copy.proposals.heading}
                </span>
                <Box className={classes.cardContainer}>
                    {data.map((proposal: IFollowUp, index: number) => (
                        <StaticCard
                            onClick={() => {
                                handleSubmitPrompt(proposal.customer_facing);
                            }}
                            key={`StaticCard${index}`}
                            message={proposal.customer_facing}
                            // Dynamic Image
                            backgroundImage={proposal.image}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default Proposals;
